import React, { useState } from 'react';
import { SectionWrapper } from './SectionWrapper';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: '¿Cuánto tiempo toma ver resultados?',
    a: 'La mayoría nota una diferencia en la consolidación del sueño en las primeras 72 horas.'
  }, {
    q: '¿Tengo que dejar de amamantar?',
    a: 'No. El método se adapta a las tomas nocturnas, enfocándose en cómo el bebé vuelve a dormirse.'
  }, {
    q: '¿Mi bebé sufrirá?',
    a: 'Todo lo contrario. Un bebé que duerme bien es un bebé con un desarrollo neurológico más sano.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const toggleFAQ = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };
  return <div className="bg-cream text-navy" data-id="element-25">
      <SectionWrapper data-id="element-26">
        <div className="max-w-3xl mx-auto" data-id="element-27">
          <h2 className="text-3xl md:text-4xl font-serif text-center mb-12" data-id="element-28">
            Preguntas Frecuentes
          </h2>

          <div className="space-y-4" data-id="element-29">
            {faqs.map((faq, index) => <div key={index} className="bg-white border border-navy/10 rounded-sm overflow-hidden transition-all duration-300" data-id="element-30">
                <button onClick={() => toggleFAQ(index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-31">
                  <span className="font-serif text-lg font-bold pr-8" data-id="element-32">
                    {faq.q}
                  </span>
                  {openIndex === index ? <ChevronUp className="text-gold shrink-0" size={20} data-id="element-33" /> : <ChevronDown className="text-navy/40 shrink-0" size={20} data-id="element-34" />}
                </button>

                <div className={`px-6 overflow-hidden transition-all duration-300 ease-in-out ${openIndex === index ? 'max-h-40 pb-5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-35">
                  <p className="font-sans text-navy/70" data-id="element-36">{faq.a}</p>
                </div>
              </div>)}
          </div>
        </div>
      </SectionWrapper>
    </div>;
}